/**
 * Airship InApp Experiences.
 */
export class AirshipInApp {
    constructor(plugin) {
        this.plugin = plugin;
    }
    /**
     * Pauses messages.
     * @param paused `true` to pause, `false` to resume.
     * @returns A promise.
     */
    setPaused(paused) {
        return this.plugin.perform('inApp#setPaused', paused);
    }
    /**
     * Checks if messages are paused.
     * @returns A promise with the result.
     */
    isPaused() {
        return this.plugin.perform('inApp#isPaused');
    }
    /**
     * Sets the display interval for messages.
     * @param milliseconds Display interval
     * @returns A promise.
     */
    setDisplayInterval(milliseconds) {
        return this.plugin.perform('inApp#setDisplayInterval', milliseconds);
    }
    /**
     * Gets the display interval.
     * @returns A promise with the result.
     */
    getDisplayInterval() {
        return this.plugin.perform('inApp#getDisplayInterval');
    }
}
//# sourceMappingURL=AirshipInApp.js.map